<template>
  <div>
    <Head title="Team erstellen" />
    <div class="flex items-center mb-8 text-orfBlue-100 text-3xl font-bold">
      <loading-button text="Zurück" inverted icon-name="arrow-left" func="link" :href="'/departments/' + department.id + '/edit'" class="mb-4 sm:mb-0 sm:mr-4"/>
      <div class="mt-1">{{department.name}}</div>
      <div class="text-orfBlue-100 mx-4 mt-1">|</div>
      <div class="flex items-center mt-1 text-orfBlue-100 text-lg md:text-xl">
        <span>Team erstellen</span>
      </div>
    </div>
    <div class="max-w-2xl bg-white rounded-md shadow ">
      <form @submit.prevent="store">
        <div class="flex justify-between items-center">
          <div class="flex flex-wrap w-2/3 -mb-8 -mr-6 p-8">
            <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 items-center justify-between w-full" label="Name" />
          </div>
          <div class="flex flex-col w-1/3 items-center p-8" v-if="false">
            <label class="form-label" for="color">Farbe: </label>
            <input id="color" v-model="form.color" type="color" :style="['background: ' + form.color]" class="shadow rounded-full h-10 w-10 cursor-pointer"/>
          </div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" text="Team erstellen" class="ml-auto" icon-name="save" icon-custom-icon/>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import HeroIcon from '@/Shared/HeroIcon.vue'

export default {
  components: {
    HeroIcon,
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    department: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        color: '#59c7f9',
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/departments/' + this.department.id + '/teams')
    },

  },
}
</script>
<style>
</style>
